<div id="page-wrapper">
    <ebs-page-header class="hidden-print"></ebs-page-header> 
    <router-outlet></router-outlet>
    
</div>